import { ROUTES } from '@dashboard/router/routeNames'

export default [
  {
    path: 'flows',
    children: [
      {
        name: ROUTES.OFFERFUNNELS,
        path: '',
        component: () => import('./pages/FlowsIndex.vue'),
        meta: {
          title: 'Flows',
          description: `Flows are powerful funnels that allow you to show the right offers, questions, and more to the right people.`,
          rightyPrompts: [
            // {
            //   label: 'Create a quiz',
            //   prompt: 'Help me create a new quiz flow to segment my visitors. What questions should I ask to better understand my audience?',
            //   autoAction: 'create_quiz_flow'
            // },
            // {
            //   label: 'Create a survey',
            //   prompt: 'Help me build a survey to learn more about my visitors. What insights am I trying to gather?',
            //   autoAction: 'create_survey_flow'
            // },
            {
              label: 'Flow performance',
              drawerLabel: 'Compare my flow performance',
              prompt:
                'Compare my flows by completion rate and identify which ones need attention. Which flows are working well and which need improvement?'
            }
          ]
        }
      },
      {
        name: ROUTES.CREATEOFFERFUNNEL,
        path: 'new',
        component: () => import('./pages/FlowNew.vue'),
        meta: {
          title: 'New flow'
        }
      },
      {
        name: ROUTES.OFFERFUNNEL,
        path: ':offerFunnelId',
        component: () => import('./pages/FlowShow.vue'),
        props: true,
        meta: {
          fullScreen: true,
          rightyPrompts: [
            {
              label: 'Optimize',
              drawerLabel: 'How can I optimize this flow?',
              prompt:
                'Analyze this flow and suggest optimizations. Look at the question order, completion rates, and overall structure to help me improve completions.'
            },
            {
              label: 'Explain',
              drawerLabel: 'Explain what this flow does',
              prompt:
                "Analyze this flow and let me know what's going on in it. Point out any issues that I might have missed."
            },
            {
              label: 'Improve questions',
              drawerLabel: 'How can I improve these questions?',
              prompt:
                'Review the questions in this flow. Are they clear? Is the order optimal? How can I improve the question experience?'
            },
            {
              label: 'Find drop-offs',
              drawerLabel: 'Where are visitors dropping off?',
              prompt:
                'Where are visitors dropping off in this flow? Analyze the completion data and suggest how to reduce abandonment.'
            }
          ]
        },
        children: [
          {
            name: ROUTES.OFFERFUNNELNODE,
            path: ':uuid',
            component: () => import('./pages/NodeEdit.vue')
          }
        ]
      }
    ]
  }
]
